import PropTypes from 'prop-types';
import { elastic_module } from './elastic_module';
import { existences } from './existences';
import { intervention } from './intervention';

export const interventionZone = PropTypes.shape({
  id: PropTypes.number.isRequired,
  area: PropTypes.number,
  bbox: PropTypes.shape({
    xmin: PropTypes.number,
    ymin: PropTypes.number,
    xmax: PropTypes.number,
    ymax: PropTypes.number
  }).isRequired,
  categories: PropTypes.arrayOf(PropTypes.number).isRequired,
  categoryGroups: PropTypes.arrayOf(PropTypes.number).isRequired,
  centroid: PropTypes.shape({
    lat: PropTypes.number,
    lon: PropTypes.number,
  }).isRequired,
  cuartel: PropTypes.string,
  is_reserved_area: PropTypes.bool,
  elastic_module: PropTypes.arrayOf(elastic_module),
  fire_risk: PropTypes.string,
  interventions: PropTypes.arrayOf(intervention),
  machinery_difficulty: PropTypes.string,
  planned_interventions: PropTypes.bool,
  refcat: PropTypes.string,
  species: PropTypes.arrayOf(existences),
  stratum: PropTypes.string,
  sxpublica: PropTypes.bool,
  type: PropTypes.number,
  ua: PropTypes.string,
  uo: PropTypes.string
});